import 'es6-promise/auto';
import Vue from 'vue';
import Vuex from 'vuex';
// import VuePortal from '@linusborg/vue-simple-portal';
import PortalVue from 'portal-vue';
import product from '@/store/product';
import itemLists from '@/store/item-lists';

import ClickOutsideDirective from '@/directives/ClickOutsideDirective';
import FocusDirective from '@/directives/FocusDirective';
import LazyLoadDirective from '@/directives/LazyLoadDirective';

import CartActionsMixin from '@/mixins/CartActionsMixin';
import FavoriteActionsMixin from '@/mixins/FavoriteActionsMixin';
import LoginActionsMixin from '@/mixins/LoginActionsMixin';

import ItemListModal from '@components/ProductDetail/ItemListModal';
import Modal from '@components/Common/Modal';
import ProductDetails from '@components/ProductDetail/ProductDetails';
import ProductSwatches from '@components/ProductDetail/ProductSwatches';
import DiscontinuedSwatches from '@components/ProductDetail/DiscontinuedSwatches';
import PromptLoginModal from '@components/ProductDetail/PromptLoginModal';
import SvgLoader from '@components/Common/SvgLoader';
import Toggle from '@components/Common/Toggle';
import { FocusTrap } from 'focus-trap-vue';

const debug = process.env.NODE_ENV !== 'production';

Vue.config.productionTip = false;
Vue.prototype.$http = window.axios;

Vue.directive('click-outside', ClickOutsideDirective);
Vue.directive('focus', FocusDirective);
Vue.directive('lazyload', LazyLoadDirective);

Vue.use(Vuex);
// Vue.use(VuePortal, {
//   name: 'Portal',
//   selector: '#portal',
// });
Vue.use(PortalVue);

const productApp = new Vue({
  el: '#product-mount',

  components: {
    DiscontinuedSwatches,
    FocusTrap,
    Modal,
    ProductCarouselSwiper: () => import('@components/ProductDetail/ProductCarouselSwiper'),
    ProductDetails,
    ProductSwatches,
    ItemListModal,
    PromptLoginModal,
    Toggle,
    SvgLoader,
  },

  mixins: [
    CartActionsMixin,
    FavoriteActionsMixin,
    LoginActionsMixin,
  ],

  store: new Vuex.Store({
    modules: {
      itemLists,
      product,
    },
    strict: debug,
  }),

  data: () => ({
    isItemListModalOpen: false,
  }),
});
